import React from "react"

export default function useInactivityDetection() {
    const [inactive, setInactive] = React.useState(true);

    React.useEffect(() => {
        let eventTimeoutId: number;

        window.addEventListener("click", handleEvent);
        window.addEventListener("scroll", handleEvent);
        window.addEventListener("mousemove", handleEvent);
        window.addEventListener("keydown", handleEvent);
        window.addEventListener("pointerdown", handleEvent);
        window.addEventListener("pointermove", handleEvent);

        function handleEvent() {
            if (inactive) {
                setInactive(false);
            }

            window.clearTimeout(eventTimeoutId);

            eventTimeoutId = window.setTimeout(() => {
                setInactive(true);
            }, 300);
        }

        return () => {
            window.clearTimeout(eventTimeoutId);
            window.removeEventListener("click", handleEvent);
            window.removeEventListener("scroll", handleEvent);
            window.removeEventListener("mousemove", handleEvent);
            window.removeEventListener("keydown", handleEvent);
            window.removeEventListener("pointerdown", handleEvent);
            window.removeEventListener("pointermove", handleEvent);
        }
        // eslint-disable-next-line
    }, []);

    return inactive
}
